// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal-module--container--1o1XU","video":"Modal-module--video--2DQFG","button":"Modal-module--button--2RTsw","buttonClose":"Modal-module--buttonClose--3VUTp"};